module.exports = __webpack_public_path__ + "img/agworld.719aa9b7.png";